import { render, staticRenderFns } from "./ActivityFoods.vue?vue&type=template&id=42726ea0&scoped=true&"
import script from "./ActivityFoods.vue?vue&type=script&lang=js&"
export * from "./ActivityFoods.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFoods.vue?vue&type=style&index=0&id=42726ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42726ea0",
  null
  
)

export default component.exports